import mapActions from './mapActions';

export default mapActions('business_trips_cars', {
    fetchAll_url(data) {
        return `/api/working_hours/business_trips_cars/${data.year}/${data.month}`;
    }
});